import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LangProvider } from "@/components/site/common";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Stats } from "@/components/site/Stats";
import { Installation } from "@/components/site/Installation";
import { AmcPlans } from "@/components/site/AmcPlans";
import { AddOns } from "@/components/site/AddOns";
import { Gallery } from "@/components/site/Gallery";
import { Benefits } from "@/components/site/Benefits";

import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppWidget } from "@/components/site/WhatsAppWidget";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Stats />
          <AmcPlans />
          <Installation />
          <AddOns />
          <Gallery />
          <Benefits />
          <Contact />
        </main>
        <Footer />
        <WhatsAppWidget />
      </div>
    </LangProvider>
  );
}

export default App;
